import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./JustPlayChooser.css";
import { colourSuits } from "../UI/SuitText";
import JustPlayWaiting from "./JustPlayWaiting";

/**
 * "Just Play" landing: pick what to play before any table appears.
 * Each destination applies its own members gate, so this page has none.
 */
const OPTIONS = [
  {
    to: "/just-play/problem-hands",
    label: "Problem hands",
    icon: "fas fa-puzzle-piece",
    tone: "puzzle",
  },
  {
    to: "/just-play/guided-bidding",
    label: "Guided bidding",
    icon: "fas fa-comments",
    tone: "guided",
  },
  // Guided play (Paul, 13 Oct 2026): LOCAL PREVIEW ONLY until he says publish - never shown on the live site.
  ...(typeof window !== "undefined" && /^(localhost|127.0.0.1)$/.test(window.location.hostname)
    ? [{ to: "/just-play/guided-play", label: "Guided play", icon: "fas fa-hand-paper", tone: "guided" }]
    : []),
  {
    to: "/just-play/practice",
    label: "Play random hands",
    icon: "fas fa-random",
    tone: "table",
  },
  {
    to: "/weekly",
    label: "Weekly tournament",
    icon: "fas fa-trophy",
    tone: "trophy",
  },
];

// First step (Paul, 18 Oct 2026): "in Just play, start with With Partner / Without Partner".
// With Partner opens the partner hub; Without Partner shows the solo options (?solo).
const FIRST = [
  { to: "/partner", label: "With Partner", icon: "fas fa-users", tone: "guided" },
  { to: "/just-play?solo", label: "Without Partner", icon: "fas fa-user", tone: "table" },
];

export default function JustPlayChooser({ location }) {
  const solo = new URLSearchParams((location && location.search) || "").has("solo");
  return (
    <div className="jpc-page">
      <Helmet>
        <title>Just Play — Bridge Champions</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 className="jpc-title">Just Play</h1>
      <JustPlayWaiting />
      {solo && (
        <Link to="/just-play" className="jpc-back">← With Partner / Without Partner</Link>
      )}
      <div className="jpc-grid">
        {(solo ? OPTIONS : FIRST).map((o) => (
          <Link key={o.to} to={o.to} className={`jpc-card jpc-card--${o.tone}`}>
            <span className="jpc-icon" aria-hidden="true">
              <i className={o.icon} />
            </span>
            <span className="jpc-label">{colourSuits(o.label)}</span>
            <span className="jpc-arrow" aria-hidden="true">
              →
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
